import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import ServicesSection from './components/ServicesSection';
import HostingExperienceSection from './components/HostingExperienceSection';
import FundingSection from './components/FundingSection';
import HostToolkitSection from './components/HostToolkitSection';
import PartnershipsSection from './components/PartnershipsSection';
import NewsletterSection from './components/NewsletterSection';
import ContactSection from './components/ContactSection';

export default function Home() {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>
        <HeroSection />
        <ServicesSection />
        <HostingExperienceSection />
        <FundingSection />
        <HostToolkitSection />
        <PartnershipsSection />
        <NewsletterSection />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
}
